export const APP_ICON = "perm_identity";
export const APP_NAME = "KEYCLOAK-AUTH-MANAGER-MAIN.NAME"